import { ElMessage } from 'element-plus'

import { getPlatforms } from '@/api/config'
import { getSystemVersion } from '@/api/login'
import { getToken } from '@/utils/auth'

import {
  APPLICATION_AVAILABLE_USER_ROLES,
  APPLICATION_STARTPOINT,
  APPLICATION_WHITE_LIST
} from '../application.constants'
import store from '../store'

const fetchInfoAboutUser = async () => {
  try {
    const {
      data: { roles }
    } = await store.dispatch('GetUserInfo')

    if (!roles.includes('EDITOR_NOTIFICATION')) {
      const { data: platforms } = await getPlatforms()

      store.dispatch('setSystemPlatforms', platforms)
    }

    const {
      data: { app }
    } = await getSystemVersion()

    store.dispatch('setSystemVersion', app.version)
  } catch (_) {
    await store.dispatch('FedLogOut')
    return '/login'
  }
}

export const authorizationGuard = async (to, from) => {
  const isAuthorized = !!getToken()
  const hasInfoAboutRoles = store.getters.roles.length > 0

  if (APPLICATION_WHITE_LIST.includes(to.path)) return true

  if (!isAuthorized) {
    const savedToPath = to.path.length > '/'.length ? to.fullPath : undefined
    const isSessionLost = from.query.sessionLost

    if (savedToPath || isSessionLost) {
      ElMessage.error('Verification failed, please login again')
    }

    sessionStorage.setItem('savedToPath', savedToPath)
    await store.dispatch('FedLogOut')

    return { path: '/login' }
  }

  if (to.meta?.isEnabled && typeof to.meta.isEnabled === 'function' && !to.meta.isEnabled()) {
    return { path: '/404' }
  }

  if (!hasInfoAboutRoles) {
    await fetchInfoAboutUser()
  }

  if (!to.meta.roles || store.getters.roles.some(userRole => to.meta.roles.includes(userRole))) {
    return true
  }

  return startPageGuard()
}

export const startPageGuard = () => {
  const hasInfoAboutRoles = store.getters.roles.length > 0
  const savedToPath = sessionStorage.getItem('savedToPath')

  if (savedToPath) {
    sessionStorage.removeItem('savedToPath')
    return savedToPath
  }

  if (!hasInfoAboutRoles) return '/dashboard'

  const userMostSignificantRole = APPLICATION_AVAILABLE_USER_ROLES.find(role => store.getters.roles.includes(role))
  return APPLICATION_STARTPOINT[userMostSignificantRole]
}

export const loginPageGuard = () => {
  const isAuthorized = !!getToken()

  if (isAuthorized) return startPageGuard()

  return true
}

function isEnabled(route) {
  return route && route.meta && route.meta.isEnabled && typeof route.meta.isEnabled === 'function'
    ? route.meta.isEnabled()
    : true
}

export const basicRouteGuard = route => {
  if (
    store.getters.roles.some(userRole => route.meta?.roles?.includes(userRole)) &&
    !route.hidden &&
    isEnabled(route)
  ) {
    return true
  }

  return false
}
